/* Smart size finder — body measurements + fit profile → recommended variant size. */
(function () {
  'use strict';

  var GARMENT_WEIGHTS = {
    top: { height: 0.65, weight: 0.35 },
    bottom: { height: 0.45, weight: 0.55 },
    outerwear: { height: 0.55, weight: 0.45 },
    dress: { height: 0.6, weight: 0.4 }
  };

  var FIT_OFFSETS = {
    runs_small: 1,
    true_to_size: 0,
    runs_large: -1,
    oversized: -1
  };

  var context = {
    fitProfile: 'true_to_size',
    garmentType: 'top',
    availableSizes: null
  };

  function parseRules(raw) {
    if (!raw) return [];
    if (Array.isArray(raw)) return raw;
    if (raw.rules && Array.isArray(raw.rules)) return raw.rules;
    return [];
  }

  function getDefaults(raw) {
    if (!raw || Array.isArray(raw)) return {};
    return raw.defaults || {};
  }

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function normalizeOptionName(option) {
    if (option == null) return '';
    if (typeof option === 'string') return option;
    if (typeof option === 'object' && option.name) return option.name;
    return String(option);
  }

  function extractSizeOption(product) {
    if (!product || !product.options) return { index: -1, values: [] };

    var sizeIndex = -1;
    product.options.forEach(function (option, index) {
      if (/size/i.test(normalizeOptionName(option))) sizeIndex = index;
    });
    if (sizeIndex === -1) return { index: -1, values: [] };

    var values = [];
    (product.variants || []).forEach(function (variant) {
      var value = variant.options[sizeIndex];
      if (value != null && values.indexOf(value) === -1) values.push(value);
    });
    return { index: sizeIndex, values: values };
  }

  function buildRuleTargets(rules) {
    return rules.map(function (rule, index) {
      var prev = rules[index - 1];
      var minHeight = prev ? prev.maxHeight : 0;
      var minWeight = prev ? prev.maxWeight : 0;
      return {
        size: rule.size,
        maxHeight: rule.maxHeight,
        maxWeight: rule.maxWeight,
        targetHeight: (minHeight + rule.maxHeight) / 2,
        targetWeight: (minWeight + rule.maxWeight) / 2
      };
    });
  }

  function snapToAvailable(size, availableSizes, rules) {
    if (!availableSizes || !availableSizes.length) return size;
    if (availableSizes.indexOf(size) > -1) return size;

    var order = rules.map(function (rule) { return rule.size; });
    var targetIndex = order.indexOf(size);
    if (targetIndex === -1) return availableSizes[0];

    for (var offset = 1; offset < order.length; offset += 1) {
      var larger = order[targetIndex + offset];
      var smaller = order[targetIndex - offset];
      if (larger && availableSizes.indexOf(larger) > -1) return larger;
      if (smaller && availableSizes.indexOf(smaller) > -1) return smaller;
    }
    return availableSizes[availableSizes.length - 1];
  }

  function recommendSize(heightCm, weightKg, config) {
    var rules = config.rules || [];
    if (!rules.length) {
      return { size: null, reason: 'nomatch' };
    }

    var garmentType = GARMENT_WEIGHTS[config.garmentType] ? config.garmentType : 'top';
    var weights = GARMENT_WEIGHTS[garmentType];
    var targets = buildRuleTargets(rules);

    var bestIndex = 0;
    var bestDistance = Infinity;

    targets.forEach(function (target, index) {
      var heightDelta = Math.abs(heightCm - target.targetHeight) / Math.max(target.targetHeight, 1);
      var weightDelta = Math.abs(weightKg - target.targetWeight) / Math.max(target.targetWeight, 1);
      var distance = heightDelta * weights.height + weightDelta * weights.weight;

      if (heightCm <= target.maxHeight && weightKg <= target.maxWeight) {
        distance *= 0.85;
      }

      if (distance < bestDistance) {
        bestDistance = distance;
        bestIndex = index;
      }
    });

    var ceilingIndex = targets.findIndex(function (target) {
      return heightCm <= target.maxHeight && weightKg <= target.maxWeight;
    });
    if (ceilingIndex === -1) ceilingIndex = targets.length - 1;

    var index = Math.round((bestIndex + ceilingIndex) / 2);
    index += FIT_OFFSETS[config.fitProfile] || 0;
    index = clamp(index, 0, rules.length - 1);

    var size = snapToAvailable(rules[index].size, config.availableSizes, rules);
    return {
      size: size,
      reason: 'match',
      fitProfile: config.fitProfile,
      adjusted: (FIT_OFFSETS[config.fitProfile] || 0) !== 0
    };
  }

  window.SizeFinder = {
    setContext: function (next) {
      context = Object.assign({}, context, next || {});
    },

    getContext: function () {
      return Object.assign({}, context);
    },

    setContextFromProduct: function (product, overrides) {
      var sizeOption = extractSizeOption(product);
      var base = Object.assign({}, context, overrides || {});
      if (sizeOption.values.length) base.availableSizes = sizeOption.values;
      context = base;
    },

    parseConfig: function (raw) {
      var rules = parseRules(raw);
      var defaults = getDefaults(raw);
      return {
        rules: rules,
        fitProfile: defaults.fitProfile || 'true_to_size',
        garmentType: defaults.garmentType || 'top'
      };
    },

    calculate: function (heightCm, weightKg, rawConfig, overrides) {
      var config = Object.assign({}, this.parseConfig(rawConfig), context, overrides || {});
      return recommendSize(heightCm, weightKg, config);
    }
  };
})();
